/* Copyright 2025 Supovia LLC */
import http from './http.js'

export default function get(config, customFailure) {
  config.method = 'GET'
  return http(config, customFailure)
}
